(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upupa-arvio-ohjaus"]) return;
  try {
    
  const reviewRedirect = document.querySelector('[data-review-target]');
  if (reviewRedirect && !reviewRedirect.querySelector('[data-review-server-error]') && !Shopify.designMode) {
    const target = new URL(reviewRedirect.dataset.reviewTarget, window.location.origin);
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview && /^\d+$/.test(preview)) target.searchParams.set('preview_theme_id', preview);
    if (reviewRedirect.querySelector('[data-review-posted]')) target.searchParams.set('arvio', 'kiitos');
    if (target.pathname !== '/') target.hash = 'arviot';
    window.location.replace(target.href);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upupa-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();
    const compositionFrames = [[0.0,0.080702,0.919298],[2.66667,0.219298,0.782456],[2.86667,0.219298,0.780702],[3.6,0.219298,0.782456],[3.73333,0.217544,0.782456],[4.06667,0.219298,0.782456],[4.4,0.0,1.0],[4.73333,0.217544,0.782456],[10.6,0.219298,0.773684],[10.73333,0.219298,0.780702],[11.06667,0.219298,0.782456],[11.33333,0.217544,0.782456],[11.66667,0.219298,0.782456],[12.46667,0.150877,0.849123],[14.86667,0.217544,0.782456],[17.06667,0.273684,0.782456],[17.13333,0.273684,0.726316],[18.6,0.219298,0.726316],[18.8,0.219298,0.780702],[19.2,0.219298,0.782456],[20.66667,0.217544,0.782456],[23.13333,0.2,0.798246],[23.2,0.184211,0.815789],[23.53333,0.191228,0.808772],[23.6,0.189474,0.808772],[23.66667,0.138596,0.861404],[23.73333,0.010526,0.989474],[23.8,0.0,1.0],[24.13333,0.159649,0.840351],[25.2,0.124561,0.840351],[25.6,0.124561,0.877193],[27.26667,0.122807,0.877193],[27.46667,0.001754,0.877193],[27.6,0.001754,0.884211],[27.66667,0.001754,0.924561],[27.73333,0.001754,1.0],[27.8,0.003509,1.0],[27.86667,0.042105,1.0],[27.93333,0.075439,1.0],[28.0,0.178947,1.0],[28.06667,0.219298,0.878947],[28.13333,0.219298,0.877193],[28.26667,0.219298,0.875439],[28.33333,0.217544,0.782456],[28.66667,0.219298,0.782456],[29.73333,0.217544,0.782456],[29.8,0.0,0.985965],[29.86667,0.0,1.0]];
    function fitSourceComposition(video) {
      if (!document.body.classList.contains('upupa-home-light')) return;
      const lifecycle = new AbortController();
      let callbackId;
      let lastKey;
      function renderComposition(mediaTime = video.currentTime) {
        if (!video.isConnected) { stop(); return; }
        if (!video.currentSrc.includes('01d3a732d28144a8b6a7483ff0074247') || !video.videoWidth || !video.videoHeight) {
          video.classList.remove('upupa-hero__video--full-composition');
          lastKey = undefined;
          return;
        }
        let position = 0;
        while (position + 1 < compositionFrames.length && compositionFrames[position + 1][0] <= mediaTime) position += 1;
        const [, top, bottom] = compositionFrames[position];
        const ratio = video.videoHeight / video.videoWidth;
        const key = `${top}:${bottom}:${ratio}`;
        if (key === lastKey) return;
        lastKey = key;
        const width = Math.min(100, 100 / (ratio * (bottom - top)));
        const height = width * ratio;
        video.style.setProperty('--composition-width', `${width}%`);
        video.style.setProperty('--composition-height', `${height}%`);
        video.style.setProperty('--composition-left', `${(100 - width) / 2}%`);
        video.style.setProperty('--composition-offset', `${(100 - height * (bottom - top)) / 2 - height * top}%`);
        video.style.setProperty('--composition-top', `${top * 100}%`);
        video.style.setProperty('--composition-bottom', `${(1 - bottom) * 100}%`);
        video.classList.add('upupa-hero__video--full-composition');
      }
      function stop() {
        lifecycle.abort();
        if (callbackId !== undefined && typeof video.cancelVideoFrameCallback === 'function') video.cancelVideoFrameCallback(callbackId);
      }
      function updateFrame(_now, metadata) {
        renderComposition(metadata.mediaTime);
        if (!lifecycle.signal.aborted) callbackId = video.requestVideoFrameCallback(updateFrame);
      }
      const update = () => renderComposition();
      video.addEventListener('loadedmetadata', update, { signal:lifecycle.signal });
      video.addEventListener('timeupdate', update, { signal:lifecycle.signal });
      video.addEventListener('seeked', update, { signal:lifecycle.signal });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target instanceof Element && event.target.contains(video)) stop();
      }, { signal:lifecycle.signal });
      renderComposition();
      if (typeof video.requestVideoFrameCallback === 'function') callbackId = video.requestVideoFrameCallback(updateFrame);
    }

    function startHeroVideos() {
      document.querySelectorAll('[data-upupa-hero-video] video').forEach(video => {
        video.controls = false;
        video.defaultMuted = true;
        video.muted = true;
        video.volume = 0;
        video.loop = true;
        video.playsInline = true;
        video.autoplay = true;
        video.play().catch(() => {});
        if (!initialized.has(video)) {
          initialized.add(video);
          fitSourceComposition(video);
          video.addEventListener('canplay', () => video.play().catch(() => {}), { once:true });
        }
      });
    }
    startHeroVideos();
    document.addEventListener('DOMContentLoaded', startHeroVideos, { once:true });
    document.addEventListener('shopify:section:load', startHeroVideos);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) startHeroVideos(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upupa-menu-kierto"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanups = new WeakMap();
    function init(root) {
      if (root.dataset.cycleReady) return;
      const source = document.getElementById('upupa-menu-data');
      const pool = document.querySelector('[data-upupa-cal] [data-el="pool"]');
      const labelsSource = root.querySelector('[data-cycle-labels]');
      if (!source || !pool || !labelsSource) return;
      let menu, labels;
      try { menu = JSON.parse(source.textContent); labels = JSON.parse(labelsSource.textContent); }
      catch (_) { return; }
      if (!menu.days?.length || !menu.h?.length || menu.days.length % 7) return;
      const products = new Map();
      pool.querySelectorAll('.upupa-card[data-handle]').forEach(card => {
        const link = card.querySelector('a[data-upupa-link]');
        const title = card.querySelector('.t');
        if (link && title) products.set(card.dataset.handle, {
          title: title.textContent.trim(), url: link.getAttribute('href'),
          price: card.querySelector('.p')?.textContent.trim() || '',
          image: card.querySelector('img')?.getAttribute('src') || '',
          actions: card.querySelector('[data-upupa-actions]')
        });
      });
      root.dataset.cycleReady = 'true';
      const controller = new AbortController();
      const listen = (target, event, fn) => target.addEventListener(event, fn, { signal: controller.signal });
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const rail = root.querySelector('[data-menu-rail]');
      const track = root.querySelector('[data-menu-track]');
      const strip = root.querySelector('[data-menu-strip]');
      const motionButton = root.querySelector('[data-menu-motion]');
      let clone;
      function motionPreference() {
        if (reduced.matches) {
          rail.classList.remove('is-looping');
          clone?.remove(); clone = null; motionButton.hidden = true;
        } else if (strip.children.length > 1) {
          if (!clone) {
            clone = strip.cloneNode(true);
            clone.removeAttribute('data-menu-strip');
            clone.setAttribute('data-menu-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.inert = true;
            track.append(clone);
          }
          rail.classList.add('is-looping'); motionButton.hidden = false;
        }
      }
      motionPreference();
      listen(reduced, 'change', motionPreference);
      listen(motionButton, 'click', () => {
        const paused = rail.classList.toggle('is-paused');
        motionButton.setAttribute('aria-pressed', String(paused));
        motionButton.textContent = paused ? labels.resume : labels.pause;
      });
      const visibility = new IntersectionObserver(entries => {
        rail.classList.toggle('is-offscreen', !entries[0].isIntersecting);
      });
      visibility.observe(rail);
      listen(document, 'visibilitychange', () => {
        track.style.animationPlayState = document.hidden ? 'paused' : '';
      });
      cleanups.set(root, () => { controller.abort(); visibility.disconnect(); });
      const tablist = root.querySelector('[data-cycle-tabs]');
      const panelsRoot = root.querySelector('[data-cycle-panels]');
      const tabs = [], panels = [];
      const weekNav = root.querySelector('[data-cycle-nav]');
      const previousWeek = root.querySelector('[data-cycle-previous]');
      const nextWeek = root.querySelector('[data-cycle-next]');
      let selectedWeek = 0;
      const shortDateFormat = new Intl.DateTimeFormat(document.documentElement.lang || 'fi', { day:'numeric', month:'numeric', timeZone:'UTC' });
      const dateFormat = new Intl.DateTimeFormat(document.documentElement.lang || 'fi', { day:'numeric', month:'numeric', year:'numeric', timeZone:'UTC' });
      const anchor = Date.parse(menu.anchor + 'T00:00:00Z');
      function node(tag, className, text) {
        const el = document.createElement(tag);
        if (className) el.className = className;
        if (text) el.textContent = text;
        return el;
      }
      function product(index) {
        const item = products.get(menu.h[index]);
        if (!item) return null;
        const row = node('div', 'upupa-cycle__product');
        const link = node('a');
        link.setAttribute('href', item.url);
        if (item.image) {
          const image = node('img');
          const url = new URL(item.image, window.location.origin);
          url.searchParams.set('width', '160'); image.src = url.href;
          image.width = 40; image.height = 40; image.alt = ''; image.loading = 'lazy';
          image.sizes = '40px';
          image.srcset = [80, 112, 160].map(width => { url.searchParams.set('width', width); return url.href + ' ' + width + 'w'; }).join(', ');
          link.append(image);
        } else {
          const empty = node('span', 'upupa-cycle__thumbnail-empty');
          empty.setAttribute('aria-hidden', 'true');
          link.append(empty);
        }
        const copy = node('span', 'upupa-cycle__product-copy');
        const separator = item.title.search(/\s[–—]\s/);
        const name = separator < 0 ? item.title : item.title.slice(0, separator);
        copy.append(node('span', 'upupa-cycle__name', name));
        if (separator >= 0) copy.append(node('span', 'upupa-cycle__description', item.title.slice(separator + 3)));
        link.setAttribute('aria-label', item.title);
        link.setAttribute('title', item.title);
        link.append(copy);
        row.append(link, node('span', 'upupa-cycle__price', item.price));
        if (item.actions) row.append(item.actions.cloneNode(true));
        return row;
      }
      function select(index, focus, align = false) {
        selectedWeek = index;
        previousWeek.disabled = index === 0;
        nextWeek.disabled = index === tabs.length - 1;
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (align) {
          const selectedPanel = panels[index].getBoundingClientRect();
          const tabBounds = tablist.getBoundingClientRect();
          if (selectedPanel.bottom > window.innerHeight - 12 || selectedPanel.top < tabBounds.bottom) {
            root.querySelector('.upupa-cycle__overview').scrollIntoView({ block:'start', behavior:reduced.matches ? 'instant' : 'smooth' });
          }
        }
        if (focus) tabs[index].focus({ preventScroll:true });
        const selected = tabs[index].getBoundingClientRect();
        const viewport = tablist.getBoundingClientRect();
        if (selected.right > viewport.right - 4) tablist.scrollLeft += selected.right - viewport.right + 4;
        else if (selected.left < viewport.left + 4) tablist.scrollLeft -= viewport.left - selected.left + 4;
      }
      for (let week = 0; week < menu.days.length / 7; week++) {
        const first = menu.days[week * 7 + 1], second = menu.days[week * 7 + 3];
        const name = labels.week + ' ' + (week + 1);
        const tab = node('button', 'upupa-cycle__tab');
        tab.append(node('span', 'upupa-cycle__tab-label', name));
        if (Number.isFinite(anchor)) {
          tab.append(node('span', 'upupa-cycle__tab-dates',
            shortDateFormat.format(anchor + (week * 7 + 1) * 86400000) + '–' +
            shortDateFormat.format(anchor + (week * 7 + 5) * 86400000)));
        }
        tab.type = 'button'; tab.id = 'menu-kierto-tab-' + week;
        tab.setAttribute('role', 'tab');
        const panel = node('div', 'upupa-cycle__panel');
        panel.id = 'menu-kierto-panel-' + week;
        panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', tab.id); panel.tabIndex = 0;
        tab.setAttribute('aria-controls', panel.id);
        const panelHead = node('div', 'upupa-cycle__panel-head');
        panelHead.append(node('h3', '', name));
        if (Number.isFinite(anchor)) panelHead.append(node('p', 'upupa-cycle__dates',
          dateFormat.format(anchor + (week * 7 + 1) * 86400000) + ' – ' +
          dateFormat.format(anchor + (week * 7 + 5) * 86400000) + ' · ' + labels.first_cycle));
        panel.append(panelHead);
        const mains = node('div', 'upupa-cycle__mains');
        [[first[0], labels.first_days], [second[0], labels.second_days]].forEach(([index, days]) => {
          const row = product(index);
          if (!row) return;
          const card = node('div', 'upupa-cycle__main');
          card.append(node('h4', '', labels.main + ' · ' + days), row); mains.append(card);
        });
        panel.append(mains);
        const other = node('div', 'upupa-cycle__other');
        [[labels.soup, [1]], [labels.light, [2,3]], [labels.dessert, [4,5]]].forEach(([label, indices]) => {
          const group = node('div', 'upupa-cycle__group'); group.append(node('h4', '', label));
          const entries = new Set();
          menu.days.slice(week * 7 + 1, week * 7 + 6).forEach(day => indices.forEach(index => entries.add(day[index])));
          entries.forEach(index => {
            const row = product(index);
            if (row) group.append(row);
          }); other.append(group);
        });
        panel.append(other); tabs.push(tab); panels.push(panel);
        listen(tab, 'click', () => select(week, false, true));
        listen(tab, 'keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (week + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (week + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault(); select(next, true, true);
        });
        tablist.append(tab); panelsRoot.append(panel);
      }
      listen(previousWeek, 'click', () => { if (selectedWeek > 0) select(selectedWeek - 1, true, true); });
      listen(nextWeek, 'click', () => { if (selectedWeek < tabs.length - 1) select(selectedWeek + 1, true, true); });
      select(0, false); tablist.hidden = false; weekNav.hidden = false;
    }
    function scan() { document.querySelectorAll('[data-upupa-cycle]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once:true });
    else scan();
    document.addEventListener('shopify:section:load', scan);
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('[data-upupa-cycle]').forEach(root => cleanups.get(root)?.());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
